import { apiClient } from '~/services/api-service';
import { visitorAttributionService } from '~/services/visitorAttribution';
import { AccountResponse, TaxSettingsResponse, UpdateAccountPayload, UpdateTaxSettingsPayload } from '~/types/account';
import {
  FacebookLoginPayload,
  FacebookLoginResponse,
  GoogleLoginPayload,
  GoogleLoginResponse,
  MagicLinkTokenParams,
  MagicLinkTokenResponse,
  MagicLoginResponse,
  RefreshTokenPayload,
  RefreshTokenResponse,
} from '~/types/login';

export const authenticationAPIService = {
  loginViaMagicLink: (data) => {
    // Include visitor ID if available
    const visitorData = visitorAttributionService.getVisitorIDForSignup();
    return apiClient.post<MagicLoginResponse>('/account/magic-login/', {
      ...data,
      ...visitorData,
    });
  },
  getAccountToken: (data: MagicLinkTokenParams) => {
    return apiClient.get<MagicLinkTokenResponse>(`/account/magic-login/${data?.uid}/${data?.token}/`);
  },
  getAccessTokenFromGoogle: (data: GoogleLoginPayload) => {
    // Include visitor ID if available
    const visitorData = visitorAttributionService.getVisitorIDForSignup();
    return apiClient.post<GoogleLoginResponse>('/account/social-auth/google/', {
      ...data,
      ...visitorData,
    });
  },
  // currently not used function
  getAccessTokenFromFacebook: (data: FacebookLoginPayload) => {
    // Include visitor ID if available
    const visitorData = visitorAttributionService.getVisitorIDForSignup();
    return apiClient.post<FacebookLoginResponse>('/account/social-auth/facebook/', {
      ...data,
      ...visitorData,
    });
  },
  refreshToken: (data: RefreshTokenPayload) => {
    return apiClient.post<RefreshTokenResponse>('/account/token/refresh/', data);
  },
  getAccount: () => {
    return apiClient.get<AccountResponse>('/account/');
  },
  updateAccount: (data: UpdateAccountPayload) => {
    return apiClient.patch<AccountResponse>('/account/', data);
  },
  getAccountTaxSettings: () => {
    return apiClient.get<TaxSettingsResponse>('/account/tax-settings/');
  },
  updateAccountTaxSettings: (data: UpdateTaxSettingsPayload) => {
    return apiClient.patch('/account/tax-settings/', data);
  },
  deleteAccount: () => {
    return apiClient.delete('/account/');
  },
  getUserHash: () => {
    return apiClient.get<number>('account/user-hash/');
  },
};
